import React, { Component } from 'react'
import {Button, TabContent, TabPane, Nav, NavItem, NavLink, FormGroup, Label, Input, FormText } from 'reactstrap'
import ReactDOM from 'react-dom'
import classnames from 'classnames'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import CurrencyInput from 'react-currency-input'
import {connect} from "react-redux"
import Presenter from '../../../../../asset/asset/presenter.js'
import TrackingPresenter from '../../../../../asset/tracking/presenter.js'
import MasterRecordHelperModel from '../../../../../asset/asset/helper/master.js'
import RenderHelperModel from '../../../../../asset/asset/helper/render.js'
import FormHelper from '../../../../../asset/asset/helper/form.js'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import MessageProperties from '../../../../../config/message.js'
import RequestProps from '../../../../../asset/asset/helper/request_props.js'
import PermissionProperties from '../../../../../config/permission.js'
import Gallery from 'react-fine-uploader'
import 'react-fine-uploader/gallery/gallery.css'
import TrackingRequestProps from '../../../../../asset/tracking/helper/request_props.js'
import ImageUploader from '../../../../../asset/photo/helper/request_props.js'
import ModalHelper from '../../../../../asset/asset/helper/modal.js'
import ImageModalHelper from '../../../../../asset/photo/helper/modal.js'
import UserHelper from '../../../../../helper/user.js'
import { StoreUserInfoFromMobile } from "user/action";
import DocRow from '../../../../../asset/document/helper/children/docRow.js'
import DocumentRequestProperties from '../../../../../asset/document/helper/object.request.props.js'
import DocumentPresenter from '../../../../../asset/document/presenter.js'
import lang from 'config/language' 
import PopoverHelper from 'utils/PopoverHelper';

import { toast } from 'react-toastify'
import * as FileSaver from 'file-saver'

// ******** Photo List
import PhotoList from '../../../../../asset/photo/helper/component/PhotoList.js'
import SelectQuery from '../../../../../component/SelectQuery.js'
import TabTracking from '../../../../../asset/simple_asset/helper/component/Tab/TabTracking.js'
import TabMaintenance from 'asset/simple_asset/helper/component/Tab/TabMaintenance.js'

import ModalQuestion from 'component/ModalQuestion';
import windowStop from '../../../../../utils/windowStop.js';

const { ReactNativeWebView } = window;

class AssetDetailForm extends Component{
  RenderHelper = null
  Uploader = null
  TrackingUploader = null

  constructor(props) {
    super(props)
    this.state = {
      Tracking:{
        query:'',
        TableSort:{
          asc : true,
          col:'ChekinTime',
        },
        Register:{
          modal: false,
          Site:'',
          Location:'',
          DueDate : moment(),
        },
        Update:{
          Alias : '',
          modal: false,
          Site:'',
          Location:'',
          DueDate : moment(),
        },
        Delete:{
          modal : false,
          Alias : '',
        }
      },
      ActiveDelete:{
        modal : false,
        Alias :'',
      },

      docElement           : [],
      activeTab            : '1',
      firstTimeLoad: {
        1: true
      },
      DeleteModalShow      : false,
      RegisterModalShow    : false,
      loadingUpload        : false,
      loadingDownload      : false,
      modalQuestion        : false,
      query                : props.match.params.Alias,
      Alias                : props.match.params.Alias,
      Tag                  : "",
      Name                 : "",
      Description          : "",
      SerialNumber         : "",
      PurchasedDate        : moment(),
      PurchaseCurrency     : "",
      PurchaseOrder        : "",
      PurchaseVendorName   : undefined,
      Status               : "",
      Type                 : "",
      PurchasePrice        : "0.00",

      ButtonUploadDisabled : true,
      MaxDay               : "",
      Make                 : '',
      Model                : '',
      WarrantyPeriod       : 0,
      isBroken             : false,
      isLost               : false,
      // is filter must array
      isFilter             : [],
      isFilterDefault      : [],
      readImageAfterUpload : false,
      results              : [],
      isLoading            : true,
    }
    this.Name = null

    this.disableUpload                   = true
    this.__ToogleDeleteModal__           = this.__ToogleDeleteModal__.bind(this)
    this.toogleDeleteImageModal          = this.toogleDeleteImageModal.bind(this)
    this.__ToogleRegisterTrackingModal__ = this.__ToogleRegisterTrackingModal__.bind(this)
    this.__ToogleDeleteTrackingModal__   = this.__ToogleDeleteTrackingModal__.bind(this)
    this.__ToogleUpdateTrackingModal__   = this.__ToogleUpdateTrackingModal__.bind(this)
    this.handleCheckboxChange            = this.handleCheckboxChange.bind(this)
    this.handleChangePurchase            = this.handleChangePurchase.bind(this)
    this.__OnUploadImageSuccess__        = this.__OnUploadImageSuccess__.bind(this)
    this.__OnUploadImageFailed__         = this.__OnUploadImageFailed__.bind(this)
    this.DownloadDocument                = this.DownloadDocument.bind(this)
    this.DeleteDocument                  = this.DeleteDocument.bind(this)
    this.handleMobile = this.handleMobile.bind(this);
    this.isInit = false;

    if(props.UserReducer.username){
      this.init(props);
    }
  }

  init(props = this.props){
    this.isInit = true;
    this.Uploader = new ImageUploader(
      props.UserReducer,
      props.match.params.Alias,
      this.__OnUploadImageSuccess__,
      this.__OnUploadImageFailed__,
      this,
    );
    this.TrackingUploader = new ImageUploader(
      props.UserReducer,
      props.match.params.Alias,
      this.__AddTrackingDone__,
      this
    );
    this.Uploader.Obj.methods._options.autoUpload = true;
    this.__InitRenderHelper__()
    this.__InitMasterRecordHelper__()
    this.__InitValue__()
    this.__ReadTracking__()
    this.LoadDocument();
  }

  handleChangePurchase(event, maskedvalue, floatvalue) {
    this.setState({PurchasePrice: floatvalue})
  }

  getAliasStatusByType(type=null) {
    let statusReducer = this.props.AssetStatusReducer
    if(statusReducer == null ){
      return
    }
    let alias = null
    for(let i = 0; i < statusReducer.rs.length; i++) {
      if(statusReducer.rs[i].Type === type) {
        alias = statusReducer.rs[i].Alias
        break
      }
    }
    return alias
  }

  addFilter(source, add, remove) {
    let index = source.findIndex(x => x === add)
    let findRemove = source.findIndex(x => x === remove)
    if(index === -1) {
      source.push(add)
      source.splice(findRemove, 1)
    }
    return source
  }


  //-------------- Checked Switch
  handleCheckboxChange(event) {
    let checkboxName = event.target.name
    if(event.target.checked) {
      if(checkboxName === 'cBroken') {
         this.setState({
           isBroken : !this.state.isBroken,
           isLost   : false,
           isFilter : ['broken'],
           Status   : this.getAliasStatusByType('broken')
         })
      } else {
         this.setState({
           isLost   : !this.state.isLost,
           isBroken : false,
           isFilter : ['lost'],
           Status   : this.getAliasStatusByType('lost')
         })
      }
    }else {
      if(checkboxName === 'cBroken') {
        this.setState({
          isBroken : !this.state.isBroken,
          isLost   : false,
          isFilter : this.addFilter(this.state.isFilterDefault, 'idle', 'broken'),
          Status   : this.getAliasStatusByType('idle')
        })
      }else {
        this.setState({
          isLost   : !this.state.isLost,
          isBroken : false,
          isFilter : this.addFilter(this.state.isFilterDefault, 'idle', 'lost'),
          Status   : this.getAliasStatusByType('idle')
        })
      }

    }
  }

  __ForceUpdateUI__(self,param){
    // console.log(self)
    self.setState({ ActiveDelete:{
        Alias:self.state.ActiveDelete.Alias,
        modal : false
      }
    })
    window.location.reload()
  }

  __ReadTracking__(ordering='ChekinTime'){
    TrackingPresenter.ReadTracking(
      TrackingRequestProps.ReadProps(
        "Read",
        null,
        null,
        PermissionProperties.ASSET.TRACKING.READ,
        this.state.Tracking,
        this.props,
        ordering,
        this.state.Alias
      )
    )
  }
  __ToogleDeleteModal__() {
    this.setState({DeleteModalShow:!this.state.DeleteModalShow})
  }

  __ToogleRegisterTrackingModal__() {
    this.setState({RegisterModalShow:!this.state.RegisterModalShow}) // { FIX error double modal on clear select }
  }

  __ToogleUpdateTrackingModal__() {
    this.setState(
      {
        Tracking:{
          query:this.state.Tracking.query,
          TableSort:{
            asc : this.state.Tracking.TableSort.asc,
            col:this.state.Tracking.TableSort.col,
          },
          Register:{
            modal: this.state.Tracking.Register.modal,
            Site:this.state.Tracking.Register.Site,
            Location:this.state.Tracking.Register.Location,
            DueDate : this.state.Tracking.Register.DueDate,
          },
          Update:{
            Alias : this.state.Tracking.Update.Alias,
            modal: !this.state.Tracking.Update.modal,
            Site:this.state.Tracking.Update.Site,
            Location:this.state.Tracking.Update.Location,
            DueDate : this.state.Tracking.Update.DueDate,
          },
          Delete:{
            modal : this.state.Tracking.Delete.modal,
            Alias : this.state.Tracking.Delete.Alias,
          },
        },
      }
    )
  }

  __ToogleDeleteTrackingModal__() {
    this.setState(
      {
        Tracking:{
          query:this.state.Tracking.query,
          TableSort:{
            asc : this.state.Tracking.TableSort.asc,
            col:this.state.Tracking.TableSort.col,
          },
          Register:{
            modal:this.state.Tracking.Register.modal,
            Site:this.state.Tracking.Register.Site,
            Location:this.state.Tracking.Register.Location,
            DueDate : this.state.Tracking.Register.DueDate,
          },
          Update:{
            Alias : this.state.Tracking.Update.Alias,
            modal: this.state.Tracking.Update.modal,
            Site:this.state.Tracking.Update.Site,
            Location:this.state.Tracking.Update.Location,
            DueDate : this.state.Tracking.Update.DueDate,
          },
          Delete:{
            modal : !this.state.Tracking.Delete.modal,
            Alias : this.state.Tracking.Delete.Alias,
          },
        },
      }
    )
  }

  toogleDeleteImageModal(alias='') {
    this.setState({ActiveDelete:{
      Alias:alias,
      modal : !this.state.ActiveDelete.modal
    }})
  }

  //Callback Read
  __OnReadSuccess__(self,response){
    var ActiveVal = self.props.Reducer.rs[0];

    if(ActiveVal !== undefined) {
      let statusType = ActiveVal.Status_Type

      let activeSwitch     = {broken: false,lost: false}
      let statusTypeFilter = ['idle'] // type array

      if (statusType === 'broken' ) {
        activeSwitch.broken = true
        statusTypeFilter = ['broken']

      } else if (statusType === 'lost') {
        activeSwitch.lost = true
        statusTypeFilter = ['lost']

      } else if (statusType === 'idle') {
        activeSwitch.broken = false
        activeSwitch.lost = false
        statusTypeFilter = ['idle']

      } else {
        activeSwitch.broken = false
        activeSwitch.lost = false
        statusTypeFilter = [statusType, 'idle']
      }

      self.Name = ActiveVal.Name

      self.setState(
        {
          Tag                : ActiveVal.Tag,
          Name               : ActiveVal.Name,
          Description        : ActiveVal.Description,
          SerialNumber       : ActiveVal.SerialNumber,
          PurchasedDate      : moment(ActiveVal.PurchasedDate),
          PurchaseCurrency   : ActiveVal.PurchaseCurrency ? ActiveVal.PurchaseCurrency.pk : "",
          PurchaseOrder      : ActiveVal.PurchaseOrder,
          PurchaseVendorName : ActiveVal.PurchaseVendor,
          Status             : ActiveVal.Status_Alias,
          Type               : ActiveVal.Type_Alias,
          initPurchaseCurrency : ActiveVal.PurchaseCurrency
            ? {
                pk: ActiveVal.PurchaseCurrency.pk,
                Name: ActiveVal.PurchaseCurrency.Name
              }
            : null,
          initType : {
            Alias: ActiveVal.Type_Alias,
            Name: ActiveVal.Type
          },
          initVendor: {
            Name : ActiveVal.PurchaseVendor, 
          },
          PurchasePrice      : ActiveVal.PurchasePrice,
          isLost             : activeSwitch.lost,
          isBroken           : activeSwitch.broken,
          isFilter           : statusTypeFilter,
          isFilterDefault    : statusTypeFilter,
          MaxDay             : ActiveVal.MaxDay,
          Make               : ActiveVal.Make,
          Model              : ActiveVal.Model,
          WarrantyPeriod     : ActiveVal.WarrantyPeriod,
          results            : self.props.Reducer.rs,
          isLoading          : false,
        },
        () => {
          if (self.props.location.state){
            self.toggleModalQuestion();
            self.props.history.replace({ state: undefined });
          }
        }
      )
    } else {
      self.setState({
        isLoading : false
      })
    }

  }
  __OnReadFailed__(){
    toast.error(MessageProperties.ERROR.MODEL.ASSET.FETCH.READ)
  }
  __InitValue__(){
    Presenter.ReadAsset(
      RequestProps.ReadProps(
        "Read",
        this.__OnReadSuccess__,
        this.__OnReadFailed__,
        PermissionProperties.ASSET.ASSET.READ,
        this.state,
        this.props,
        '',
        this
      )
    )

  }
  __InitMasterRecordHelper__(){
    this.MasterRecordHelper = new MasterRecordHelperModel(
      this.props.RunRedux,
      this.props.UserReducer,
      this.props.AssetStatusReducer,
    )
    this.MasterRecordHelper.LoadMasterPropsField()
  }
  __InitRenderHelper__(){
    this.RenderHelper = new RenderHelperModel()
  }
  __OnPurchasedDateChange__(value,self) {
    // self.setState(
    //   {
    //     Tracking:{
    //       query:self.state.Tracking.query,
    //       TableSort:{
    //         asc : self.state.Tracking.TableSort.asc,
    //         col:self.state.Tracking.TableSort.col,
    //       },
    //       Register:{
    //         modal: self.state.Tracking.Register.modal,
    //         Site:self.state.Tracking.Register.Site,
    //         Location:self.state.Tracking.Register.Location,
    //         DueDate : value,
    //       },
    //       Update:{
    //         Alias : self.state.Tracking.Update.Alias,
    //         modal: self.state.Tracking.Update.modal,
    //         Site:self.state.Tracking.Update.Site,
    //         Location:self.state.Tracking.Update.Location,
    //         DueDate : self.state.Tracking.Update.DueDate,
    //       },
    //       Delete:{
    //         modal : this.state.Tracking.Delete.modal,
    //         Alias : self.state.Tracking.Delete.Alias,
    //       },
    //     },
    //   }
    // )
    self.setState({
      PurchasedDate: value
    });
  }

  __HandleChanged__(state, val){
    if(val != null){
      this.setState({[state]:val.value})
      return
    }
    this.setState({[state]:''})
  }
  __HandleSiteChanged__(self,val){
    if(val !== null){
      self.setState(
        {
          Tracking:{
            query:self.state.Tracking.query,
            TableSort:{
              asc : self.state.Tracking.TableSort.asc,
              col:self.state.Tracking.TableSort.col,
            },
            Register:{
              modal: self.state.Tracking.Register.modal,
              Site:val.value,
              Location:self.state.Tracking.Register.Location,
              DueDate : self.state.Tracking.Register.DueDate,
            },
            Update:{
              Alias : self.state.Tracking.Update.Alias,
              modal: self.state.Tracking.Update.modal,
              Site:self.state.Tracking.Update.Site,
              Location:self.state.Tracking.Update.Location,
              DueDate : self.state.Tracking.Update.DueDate,
            },
            Delete:{
              modal : this.state.Tracking.Delete.modal,
              Alias : self.state.Tracking.Delete.Alias,
            },
          },
        }
      )

      return
    }else if(val === null){
      self.setState(
        {
          Tracking:{
            query:self.state.Tracking.query,
            TableSort:{
              asc : self.state.Tracking.TableSort.asc,
              col:self.state.Tracking.TableSort.col,
            },
            Register:{
              modal: !self.state.Tracking.Register.modal,
              Site:'',
              Location:self.state.Tracking.Register.Location,
              DueDate : self.state.Tracking.Register.DueDate,
            },
            Update:{
              Alias : self.state.Tracking.Update.Alias,
              modal: self.state.Tracking.Update.modal,
              Site:self.state.Tracking.Update.Site,
              Location:self.state.Tracking.Update.Location,
              DueDate : self.state.Tracking.Update.DueDate,
            },
            Delete:{
              modal : this.state.Tracking.Delete.modal,
              Alias : self.state.Tracking.Delete.Alias,
            },
          },
        }
      )

    }
  }
  //sort callback
  __SortTable__(self,label){
    if(label === self.state.Tracking.TableSort.col){
      var annotation = self.state.Tracking.TableSort.asc?"-":""
      self.setState({
        Tracking:{
          query:self.state.Tracking.query,
          TableSort:{
            asc: !self.state.Tracking.TableSort.asc,
            col:label,
          },
          Register:{
            modal: self.state.Tracking.Register.modal,
            Site:self.state.Tracking.Register.Site,
            Location:self.state.Tracking.Register.Location,
            DueDate : self.state.Tracking.Register.DueDate,
          },
          Update:{
            Alias : self.state.Tracking.Update.Alias,
            modal: self.state.Tracking.Update.modal,
            Site:self.state.Tracking.Update.Site,
            Location:self.state.Tracking.Update.Location,
            DueDate : self.state.Tracking.Update.DueDate,
          },
          Delete:{
            modal : this.state.Tracking.Delete.modal,
            Alias : self.state.Tracking.Delete.Alias,
          },
        }
      })
      self.__ReadTracking__((annotation+label))
      return
    }
    self.setState({
      Tracking:{
        query:self.state.Tracking.query,
        TableSort:{
          asc: true,
          col:label,
        },
        Register:{
          modal: self.state.Tracking.Register.modal,
          Site:self.state.Tracking.Register.Site,
          Location:self.state.Tracking.Register.Location,
          DueDate : self.state.Tracking.Register.DueDate,
        },
        Update:{
          Alias : self.state.Tracking.Update.Alias,
          modal: this.state.Tracking.Update.modal,
          Site:this.state.Tracking.Update.Site,
          Location:this.state.Tracking.Update.Location,
          DueDate : this.state.Tracking.Update.DueDate,
        },
        Delete:{
          modal : this.state.Tracking.Delete.modal,
          Alias : this.state.Tracking.Delete.Alias,
        },
      }
    })
    self.__ReadTracking__(label)
  }

  __HandleLocationChanged__(self,val){
    if(val !== null){
      self.setState(
        {
          Tracking:{
            query:self.state.Tracking.query,
            TableSort:{
              asc : self.state.Tracking.TableSort.asc,
              col:self.state.Tracking.TableSort.col,
            },
            Register:{
              modal: self.state.Tracking.Register.modal,
              Site:self.state.Tracking.Register.Site,
              Location:val.value,
              DueDate : self.state.Tracking.Register.DueDate,
            },
            Update:{
              Alias : self.state.Tracking.Update.Alias,
              modal: self.state.Tracking.Update.modal,
              Site:self.state.Tracking.Update.Site,
              Location:self.state.Tracking.Update.Location,
              DueDate : self.state.Tracking.Update.DueDate,
            },
            Delete:{
              modal : this.state.Tracking.Delete.modal,
              Alias : self.state.Tracking.Delete.Alias,
            },
          },
        }
      )
      return
    }
    self.setState(
      {
        Tracking:{
          query:self.state.Tracking.query,
          TableSort:{
            asc : self.state.Tracking.TableSort.asc,
            col:self.state.Tracking.TableSort.col,
          },
          Register:{
            modal: self.state.Tracking.Register.modal,
            Site:self.state.Tracking.Register.Site,
            Location:'',
            DueDate : self.state.Tracking.Register.DueDate,
          },
          Update:{
            Alias : self.state.Tracking.Update.Alias,
            modal: self.state.Tracking.Update.modal,
            Site:self.state.Tracking.Update.Site,
            Location:self.state.Tracking.Update.Location,
            DueDate : self.state.Tracking.Update.DueDate,
          },
          Delete:{
            modal : this.state.Tracking.Delete.modal,
            Alias : self.state.Tracking.Delete.Alias,
          },
        },
      }
    )
  }

  __OnUploadImageSuccess__(self, params){
    toast.success(MessageProperties.SUCEESS.MODEL.UPLOAD)
    self.setState({readImageAfterUpload: true})
    self.asyncCall()
  }

  __OnUploadImageFailed__(response){
    alert(response)
  }

  resolveAfter2Seconds() {
    return new Promise(resolve => {
      this.setState({readImageAfterUpload: false})
    })
  }

  async asyncCall() {
    await this.resolveAfter2Seconds()
  }

  __OnRegisterFailed__(error){
    toast.error(MessageProperties.ERROR.MODEL.ERROR_SUBMIT+error.details)
  }
  __OnUpdateSuccess__(self){
    toast.success(MessageProperties.SUCEESS.MODEL.ASSET.UPDATE)
  }
  Update(){
    if(!FormHelper.ValidateForm(this.state,MessageProperties,false)){
      return
    }
    Presenter.UpdateAsset(RequestProps.RegisterUpdateProps(this.__OnUpdateSuccess__,this.__OnRegisterFailed__,PermissionProperties.ASSET.ASSET.UPDATE,this.state,this.props,this))
  }
  __OnDeleteSuccess__(self){
    toast.success(MessageProperties.SUCEESS.MODEL.ASSET.DELETE)
    setTimeout(() => {
      self.props.history.push('/admin/master-asset')
    }, 2000)
  }
  __Delete__(){
    Presenter.DeleteAsset(RequestProps.DeleteProps(this.__OnDeleteSuccess__,this.__OnRegisterFailed__,PermissionProperties.ASSET.ASSET.DELETE,this.state,this.props,this))
  }
  //Pagination Handler
  __PreviousTrackingPage__(props){
    TrackingPresenter.ReadTracking(props)
  }
  __NextTrackingPage__(props){
    TrackingPresenter.ReadTracking(props)
  }
  __RenderActionHeaderButton__(){
    var jsx = []
    let i = 1
    if(UserHelper.HasPermission(PermissionProperties.ASSET.TRACKING.UPDATE,this.props.UserReducer)){
      jsx.push(
        <th className="text-center" key={i++}>Edit</th>
      )
    }
    if(UserHelper.HasPermission(PermissionProperties.ASSET.TRACKING.DELETE,this.props.UserReducer)){
      jsx.push(
          // hide delete
          //<th className="text-center">Delete</th>
      )
    }
    return jsx
  }

  __RenderTrackingTable__(){
    return (<TabTracking UserReducer={this.props.UserReducer} SelectedItem={this.state}></TabTracking>)
  }

  HandleSwithTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        firstTimeLoad: {
          ...this.state.firstTimeLoad,
          [tab]: true
        }
      })
    }
  }

  //AddTrackingDone
  __AddTrackingDone__(self=this){
    self.__ToogleRegisterTrackingModal__()
    toast.success(MessageProperties.SUCEESS.MODEL.TRACKING.REGISTRATION)
    self.setState(
      {
        Tracking:{
          query:self.state.Tracking.query,
          TableSort:{
            asc : self.state.Tracking.TableSort.asc,
            col:self.state.Tracking.TableSort.col,
          },
          Register:{
            modal: self.state.Tracking.Register.modal,
            Site:'',
            Location:'',
            DueDate : moment(),
          },
          Update:{
            Alias : self.state.Tracking.Update.Alias,
            modal: self.state.Tracking.Update.modal,
            Site:self.state.Tracking.Update.Site,
            Location:self.state.Tracking.Update.Location,
            DueDate : self.state.Tracking.Update.DueDate,
          },
          Delete:{
            modal : self.state.Tracking.Delete.modal,
            Alias : self.state.Tracking.Delete.Alias,
          },
        },
      }
    )
    if(self.TrackingUploader.Obj.methods.getFile(0) !== null){
      setTimeout(() => {
        window.location.reload()
      }, 3000)

    }
  }

  RenderImageUploader(){
    // Noe : Contoh penggunaan permission
    // if(UserHelper.HasPermission(PermissionProperties.ASSET.IMAGE.REGISTER,this.props.UserReducer)){
    //   return(
    //     <Gallery
    //       disabled={this.state.FieldDisabled}
    //       uploader={this.Uploader.Obj}
    //     />
    //   )
    // }

    return(
      <Gallery
        uploader={this.Uploader.Obj}
        fileInput-accept="image/*" 
      />
    )
  }

  RenderActionButton(){
    var jsx = []
    jsx.push(
      !ReactNativeWebView && <Button color="danger" key={"a"} onClick={()=>this.__ToogleDeleteModal__()}><i className="icon-trash"></i>&nbsp;Delete</Button>,
      <div className="float-right" key={"s"}>
        <Button color="primary" onClick={()=>this.Update()}>Save</Button>
      </div>
    )
    return jsx
  }

  RenderDocUploader(){
      return(
       <FormGroup>
          <Label htmlFor="file"><h5>Upload a Document</h5></Label>
            <Input
              type="file"
              name="file"
              id="exampleFile"
              accept="application/msword,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ref="docInputFile"
              onChange = {(e) => this.UploadDoc(e)}
            />
            <FormText color="muted">Upload document information IE: invoices, repairs, and an incident.</FormText>
            <Button color="primary" onClick={() => this.__RegisterUpload__()} disabled={this.state.ButtonUploadDisabled}><i className="fa fa-cloud-upload" /> Upload!</Button>
        </FormGroup>
      )
  }

  UploadDoc = (e) => {
    let file = e.target.files[0]
    if (file) {
      this.setState({ ButtonUploadDisabled : false })
      let data = new FormData()
      data.append('File', file)
      data.append('Asset', this.props.match.params.Alias)
      data.append('Filename', file.name)
      this.RegisterParams = {
        File : data,
        Filename : file.name,
      }
    }
  }

  __RegisterUpload__(){
    this.setState({ loadingUpload : true })
    DocumentPresenter.Register(
      DocumentRequestProperties.Register('upload',this.OnDocUploadSuccess,this.OnDocUploadFailed,this)
    )

  }

  OnDocUploadSuccess(params, response){
    this.self.setState({
      ButtonUploadDisabled  : true,
      loadingUpload         : false,
    })
    toast.success(params.FileName +' '+ MessageProperties.SUCEESS.MODEL.UPLOAD)
    ReactDOM.findDOMNode(this.self.refs.docInputFile).value = null
    this.self.LoadDocument()
  }

  OnDocUploadFailed(params, error){
    console.log(error)
  }

  DeleteDocument(alias){

    this.DeleteParams = {Alias : alias}
    DocumentPresenter.Delete(
      DocumentRequestProperties.Delete('delete',this.OnDocDeleteSuccess,this.OnDocUploadFailed,this)
    )
  }

  OnDocDeleteSuccess(params, response){
    toast.success(response.data.Filename +' '+ MessageProperties.SUCEESS.MODEL.DELETE)
    this.self.LoadDocument()

  }

  LoadDocument(){
    DocumentPresenter.Read(
      DocumentRequestProperties.Read('read',this.OnDocReadSuccess,this.OnDocUploadFailed,this)
    )
  }

  OnDocReadSuccess(params, response){
    this.self.setState({
      docElement : this.self.RenderListDocument(response.data.results)
    })
  }

  DownloadDocument(alias, filename){
    this.OpenParams = {
      Alias : alias,
      FileName : filename
    }
    this.setState({ loadingDownload : true })
    DocumentPresenter.Open(
      DocumentRequestProperties.Open('read', this.OnDocOpenSuccess, this.OnDocUploadFailed, this)
    )
  }

  OnDocOpenSuccess(params, response){
    const file = new File([response.data], params.data.FileName, {type: "application/octet-stream"})
    this.self.setState({ loadingDownload : false })
    FileSaver.saveAs(file)
  }

  RenderListDocument(fileData){
    let el = null
    if (fileData.length > 0){
      el = fileData.map(val => {
        return (
          <DocRow key={val.Alias} Parent={this} RowData={val} />
        )

      })
    }else{
        el = <DocRow Parent={this} RowData={null} />
    }
    return el
  }

  RenderMaintenance(){
    if (this.Name !== null){
      let dataAsset = {
        Alias: this.state.Alias,
        Name: this.state.Name
      }
      return (
        <TabMaintenance
          usedFor={'inAdmin'}
          SelectedItem={dataAsset}
          UserReducer={this.props.UserReducer}
          history={this.props.history}
        />
      )
    }else{
      return null
    }
  }

  renderImage(){
    return(
      <div className="white-background" >
        <div className="row">
          <PhotoList
            alias                  = {this.state.Alias}
            UserReducer            = {this.props.UserReducer}
            toogleDeleteImageModal = {this.toogleDeleteImageModal}
            readImageAfterUpload   = {this.state.readImageAfterUpload}
          />
          <div className="col-md-5">
            <div className="card-block white-background registration-photo-container">
              {this.RenderImageUploader()}
            </div>
            <div className="text-small" style={{'marginLeft' : '1.8rem', 'color' : '#ea0e0e'}}>
              Notes :
              <ul>
                <li>Max upload size 15 MB</li>
                <li>Allowed extensions ( jpeg, jpg, png, gif )</li>
              </ul>
            </div>
          </div>
        </div>
        {ModalHelper.DeleteModal(this)}
        {ImageModalHelper.DeleteModal(this)}
      </div> 
    )
  }

  handleMobile({ data }){
    let parsedData = JSON.parse(data);
    this.props.RunRedux(
      StoreUserInfoFromMobile(parsedData.UserReducer)
    );
  }

  toggleModalQuestion(){
    this.setState({ modalQuestion: !this.state.modalQuestion });
  }

  componentWillReceiveProps(nextProps){
    if(ReactNativeWebView){
      if(nextProps.UserReducer.username && !this.isInit){
        this.setState(
          { isLoading: true },
          () => this.init(nextProps)
        );
      }
    }
  }

  componentDidMount(){
    if(ReactNativeWebView){
      window.addEventListener("message", this.handleMobile);
      document.addEventListener("message", this.handleMobile);
      ReactNativeWebView.postMessage("mounted");
    }
  }

  componentWillUnmount(){
    windowStop()
    if(ReactNativeWebView){
      window.removeEventListener("message", this.handleMobile);
      document.removeEventListener("message", this.handleMobile);
    }
  }

  render(){ 
    const {activeTab, firstTimeLoad} = this.state
    const is_lite = ReactNativeWebView && this.props.UserReducer.props.is_lite
    // if(UserHelper.HasPermission(PermissionProperties.ASSET.ASSET.READ, this.props.UserReducer)){
    if(this.state.isLoading) {
      return(
        <div className="card-block align-center NoDataContainer height-450">
          <div>
              <i className="h1-5rem fa fa-hourglass-start"></i>
              <h5><b>Loading</b></h5>
          </div>
        </div>
      )
    }else if(this.state.results.length === 0){
      return(
        <div className="card-block align-center NoDataContainer height-450">
          <div>
            <h1 className="h1-5rem"><b>404</b></h1>
            <h5><b>Asset Not Found</b></h5>
          </div>
        </div>
      )
    } else {
      return(
        <div>
            {/*<ToastContainer position="top-center" type="default" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover />*/}
            <Nav tabs>
              <NavItem>
                <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => { this.HandleSwithTab('1'); }} >
                  Asset Details
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => { this.HandleSwithTab('2'); }} >
                  Images
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: activeTab === '3' })} onClick={() => { this.HandleSwithTab('3'); }} >
                  Asset Tracking
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={classnames({ active: activeTab === '4' })} onClick={() => { this.HandleSwithTab('4'); }} >
                  Documents
                </NavLink>
              </NavItem>
              {!is_lite &&(
              <NavItem>
                <NavLink className={classnames({ active: activeTab === '5' })} onClick={() => { this.HandleSwithTab('5'); }} >
                  Maintenance
                </NavLink>
              </NavItem>
               )}
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <div className="white-background" >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card-block white-background">
                          <div className="page-header">
                            <h4>Detail Asset</h4>
                          </div>
                          <hr/>
                          <div className="form-group">
                            <div className="row">
                              <div className="form-group col-sm-12">
                                <label htmlFor="Alias">Code</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="Alias"
                                  placeholder=""
                                  value={this.state.Alias}
                                  disabled={true}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="row">
                                <div className="form-group col-sm-8">
                                  <label htmlFor="Name">Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="Name"
                                    placeholder="Enter Asset Name"
                                    value={this.state.Name}
                                    // disabled={this.state.FieldDisabled}
                                    onChange={(event)=> this.setState({Name: event.target.value})}
                                    tabIndex="1"
                                  />
                                </div>
                                <div className="form-group col-sm-4">
                                  <label htmlFor="SerialNumber">Serial Number</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="SerialNumber"
                                    placeholder="Enter Asset Serial Number"
                                    value={this.state.SerialNumber}
                                    // disabled={this.state.FieldDisabled}
                                    onChange={(event)=> this.setState({SerialNumber: event.target.value})}
                                    tabIndex="2"
                                    />
                                </div>
                            </div>
                          </div>
                          <div className="form-group">
                            <label htmlFor="Description">Description</label>
                            <textarea
                              id="Description"
                              name="Description"
                              rows="5"
                              className="form-control"
                              placeholder="Enter Asset Description"
                              value={this.state.Description}
                              // disabled={this.state.FieldDisabled}
                              onChange={(event)=> this.setState({Description: event.target.value})}
                              tabIndex="3"
                            />
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-4">
                              <label>Vendor Name</label>
                              <SelectQuery
                                placeholder="Type Vendor"
                                value={this.state.PurchaseVendorName}
                                onChange={(event) => this.__HandleChanged__('PurchaseVendorName', event)}
                                urlKey="read-vendor-autocomplete"
                                valKey="Name"
                                valLabel="Name"
                                initOption = {this.state.initVendor}
                                isCreatable={true}
                                UserReducer={this.props.UserReducer}
                              />
                            </div>
                            <div className="form-group col-sm-4">
                              <label htmlFor="PurchaseOrder">Purchase Order</label>
                              <input type="text"
                                className="form-control"
                                id="PurchaseOrder"
                                placeholder="Purchase Order"
                                value={this.state.PurchaseOrder}
                                // disabled={this.state.FieldDisabled}
                                onChange={(event)=> this.setState({PurchaseOrder: event.target.value})}
                                tabIndex="8"
                              />
                            </div>
                            <div className="form-group col-sm-4" style={{display: is_lite ? "none" : "block" }}>
                              <label htmlFor="Type">Type</label>
                              <SelectQuery
                                // onRef = {ref=>{
                                //   if(is_lite){
                                //     ref.reload("",true)
                                //   }
                                // }}
                                name="Type"
                                placeholder="Asset Type"
                                value={this.state.Type}
                                urlKey="read-asset-type-autocomplete"
                                valKey="Alias"
                                valLabel="Name"
                                onChange={(event)=> this.setState({Type: event.value})}
                                initOption={this.state.initType}
                                UserReducer={this.props.UserReducer}
                                // disabled={this.state.FieldDisabled}
                                tabIndex="12"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-4">
                              <label>Make</label>
                              <PopoverHelper
                                id="make"
                                placement="bottom"
                                content={lang.asset_detail.make}
                              />
                              <SelectQuery
                                name="make"
                                placeholder="Type Make"
                                value={this.state.Make}
                                urlKey="read-make-autocomplete"
                                onChange={(event) => this.__HandleChanged__('Make', event)}
                                initOption={this.state.Make}
                                UserReducer={this.props.UserReducer}
                                isCreatable={true}
                                tabIndex="5"
                              />
                            </div>
                            <div className="form-group col-sm-4">
                              <label htmlFor="PurchasedDate">Purchased Date</label>
                              <DatePicker
                                id="PurchasedDate"
                                name="PurchasedDate"
                                className="form-control"
                                dateFormat="YYYY-MM-DD"
                                selected={this.state.PurchasedDate}
                                // disabled={this.state.FieldDisabled}
                                onChange={(val)=>this.__OnPurchasedDateChange__(val,this)}
                                tabIndex="9"
                              />
                            </div>
                            <div className="form-group col-sm-4">
                              <label htmlFor="MaxDay">Max Day</label>
                                <PopoverHelper
                                  id="max_day"
                                  placement="bottom"
                                  content={lang.asset_detail.max_day}
                                />
                              <input
                                type="number"
                                className="form-control"
                                min="0"
                                pattern="\d*"
                                id="MaxDay"
                                placeholder="Enter Asset Max Day"
                                value = {this.state.MaxDay}
                                onChange={
                                  (event)=> this.setState({MaxDay: event.target.value})
                                }
                                tabIndex="13"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-sm-4">
                              <label>Model</label>
                              <SelectQuery
                                name="model"
                                placeholder="Type Model"
                                value={this.state.Model}
                                urlKey="read-model-autocomplete"
                                onChange={(event) => this.__HandleChanged__('Model', event)}
                                initOption={this.state.Model}
                                isCreatable={true}
                                UserReducer={this.props.UserReducer}
                                tabIndex="6"
                              />
                            </div>
                            <div className="form-group col-sm-4">
                              <label htmlFor="PurchaseCurrency">Purchase Currency</label>
                              <SelectQuery
                                name="PurchaseCurrency"
                                placeholder="Currency"
                                value={this.state.PurchaseCurrency}
                                urlKey="read-currency-autocomplete"
                                valKey="pk"
                                valLabel="Name"
                                onChange={(event)=> this.setState({PurchaseCurrency: event.value})}
                                initOption={this.state.initPurchaseCurrency}
                                UserReducer={this.props.UserReducer}
                                disabled={this.state.FieldDisabled}
                                tabIndex="10"
                              />
                            </div>
                            <div className="form-group col-sm-4"style={{display: is_lite ? "none" : "block" }}>
                              <label>Status</label>
                              <PopoverHelper
                                id="status"
                                placement="bottom"
                                content={lang.asset_detail.status}
                              />
                              <Select
                              //  onRef = {ref=>{
                              //   if(is_lite){
                              //     ref.reload("",true)
                              //   }
                              // }}
                                placeholder="Type Asset Status"
                                value = {this.state.Status}
                                clearable={false}
                                options={this.RenderHelper.RenderMasterAutoCompleteFilter(this.props.AssetStatusReducer, this.state.isFilter)}
                                onChange={(val)=> this.setState({Status: val.value})}
                                tabIndex="14"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-md-4">
                              <label>Warranty</label>
                              <div className="input-group suffix">
                                <input
                                  type="number"
                                  min="0"
                                  pattern="\d*"
                                  className="form-control"
                                  placeholder="Warranty"
                                  value={this.state.WarrantyPeriod}
                                  onChange={(e)=>this.setState({WarrantyPeriod: e.target.value})}
                                  tabIndex="7"
                                />
                                <span className={"input-group-addon white-background"}>Months</span>
                              </div>
                            </div>
                            <div className="form-group col-md-4">
                              <label htmlFor="PurchasePrice">Purchase Price</label>
                                { ReactNativeWebView 
                                 ? (
                                     <input
                                       type="number"
                                       className="form-control"
                                       min="0"
                                       pattern="\d*"
                                       id="PurchasePrice"
                                       placeholder="Enter Asset Purchase Price"
                                       value={this.state.PurchasePrice}
                                       onChange={
                                         (event)=> this.setState({PurchasePrice: event.target.value})
                                       }
                                       tabIndex="11"
                                     />
                                   )
                                 : (
                                     <CurrencyInput
                                        className     ="form-control"
                                        id            ="PurchasePrice"
                                        autoFocus     ={false}
                                        // prefix        ={this.state.PurchaseCurrency +" "}
                                        value         ={this.state.PurchasePrice}
                                        onChangeEvent ={this.handleChangePurchase}
                                        tabIndex="11"
                                      />                 
                                    )
                                }
                            </div>
                            <div className="form-group col-sm-6 col-md-2">
                              <div>
                                <label className="spaceR">is Broken</label>
                              </div>
                              <label className="switch switch-lg switch-text switch-danger">
                                <input
                                  onChange={(event)=>this.handleCheckboxChange(event)}
                                  type="checkbox"
                                  name="cBroken"
                                  className="switch-input"
                                  checked={this.state.isBroken}
                                  tabIndex="15"
                                />
                                <span className="switch-label" data-on="Yes" data-off="No"></span>
                                <span className="switch-handle"></span>
                              </label>
                            </div>
                            <div className="form-group col-sm-6 col-md-2">
                              <div>
                                <label className="spaceR">is Lost</label>
                              </div>
                              <label className="switch switch-lg switch-text switch-danger">
                                <input
                                  onChange={(event)=>this.handleCheckboxChange(event)}
                                  name="cLost" type="checkbox"
                                  className="switch-input"
                                  checked={this.state.isLost}
                                  tabIndex="16"
                                />
                                <span className="switch-label" data-on="Yes" data-off="No"></span>
                                <span className="switch-handle"></span>
                              </label>
                            </div>
                          </div>

                          <div className="row">
                            <div className="form-group col-sm-12">
                          </div>
                        </div>
                          <hr/>
                            {this.RenderActionButton()}
                        </div>
                      </div>
                    </div>
                    {ModalHelper.DeleteModal(this)}
                  </div>
                </TabPane>

                <TabPane tabId="2">
                  {firstTimeLoad[2] && this.renderImage()}
                </TabPane>

                <TabPane tabId="3">
                  <div className="row">
                    <div className="col-md-12">
                      {firstTimeLoad[3] && this.__RenderTrackingTable__()}
                    </div>
                  </div>
                </TabPane>

                <TabPane tabId="4">
                  <div className={classnames('prepare-preview-report', {'show-f': this.state.loadingUpload})}>
                    <h3>Please wait, Uploading Documents . . .</h3>
                    <i className="fa fa-spinner fa-spin"></i>
                  </div>
                  <div className={classnames('prepare-preview-report', {'show-f': this.state.loadingDownload})}>
                    <h3>Please wait, Downloading Documents . . .</h3>
                    <i className="fa fa-spinner fa-spin"></i>
                  </div>
                  <div className="white-background" >
                    <div className="row">
                      <div className="col-md-7">
                        <div className="card-block white-background">
                          <div className="page-header">
                            <h4>Asset Documents</h4>
                          </div>
                          <hr/>
                            <div className="row">
                              {this.state.docElement}
                            </div>
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="card-block white-background registration-photo-container">
                            {this.RenderDocUploader()}
                        </div>
                      </div>
                    </div>
                    {ModalHelper.DeleteModal(this)}
                  </div>
                </TabPane>

                <TabPane tabId="5">
                  {firstTimeLoad[5] && this.RenderMaintenance()}
                </TabPane>

            </TabContent>
            {!is_lite && (
            <ModalQuestion
              isOpen={this.state.modalQuestion}
              toggle={() => this.toggleModalQuestion()}
              title="Maintenance"
              question="Do you want to input Maintenance data ?"
              onNoClick={() => null}
              onYesClick={() => this.HandleSwithTab('5')}
            />
            )}
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    UserReducer: state.UserReducer,
    CurrencyReducer : state.CurrencyReducer,
    AssetStatusReducer : state.AssetStatusReducer,
    Reducer: state.AssetReducer,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    RunRedux: (data) => {
      dispatch(data)
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetDetailForm)



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/asset/form/detail.js